// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`IP Whitelist Toggle Button Component should match snapshot 1`] = `
<mockConstructor
  checked={false}
  className="ipWhitelistToggle"
  id="ipWhitelist"
  key="ipWhitelist"
  label="IP Allow List"
  onSwitch={[Function]}
  size="small"
  style={
    {
      "margin": "0",
    }
  }
/>
`;
